// initial state
import * as base from './base.js'
const baseName = 'admin/api/banner'

const obj = base.setBaseUrl('banner', baseName)

const a = Object.assign(obj, {})
export default a
